import React from 'react';
import styles from './ComingBackSoon.module.css';

const ComingBackSoon = () => {
  return (
    <div className={styles.comingBackSoon}>
      <h2 className={styles.title}>Scheduled Maintenance</h2>
      <img src={`${process.env.PUBLIC_URL}/assets/icon-maintenance.svg`} alt="icon" className={styles.icon} />
      <p className={styles.description}>
        We are performing scheduled maintenance to improve your experience.
        <br />
        Our platform will be temporarily unavailable today from 5:00 AM - 8:00 AM EST.
        <br />
        We look forward to welcoming you back shortly.
      </p>
    </div>
  );
};

export default ComingBackSoon;
